import { render, staticRenderFns } from "./CollageCustomOverlayFields.vue?vue&type=template&id=69edc59e&scoped=true&"
import script from "./CollageCustomOverlayFields.vue?vue&type=script&lang=js&"
export * from "./CollageCustomOverlayFields.vue?vue&type=script&lang=js&"
import style0 from "./CollageCustomOverlayFields.vue?vue&type=style&index=0&id=69edc59e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69edc59e",
  null
  
)

export default component.exports